export default {
    title: "Import history",
    subtitle: "Track order and client imports for your establishment.",
    cancelConfirmTitle: "Cancel import?",
    cancelConfirmBody: "The import will be stopped. Items already processed will be kept.",
    detailsTitle: "Import details",
    close: "Close",
    details: "Details",
    cancel: "Cancel",
    preparing: "Preparing...",
    downloadFailed: "Download failed rows",
    columnType: "Type",
    columnFilename: "File",
    columnUser: "User",
    columnBranch: "Branch",
    columnStatus: "Status",
    columnProgress: "Progress",
    columnResults: "Results",
    columnDate: "Date",
    columnActions: "Actions",
    columnError: "Error",
    columnPlugin: "Integration",
    columnImporter: "Importer",
    noData: "No calculated data",
    summaryNewOrders: "New orders",
    summaryUpdatedOrders: "Updated orders",
    summaryNewClients: "New clients",
    summaryUpdatedClients: "Updated clients",
    summaryImportedOrders: "Imported orders",
    summaryFailed: "Failed rows",
    filterType: "Type",
    filterStatus: "Status",
    filterPeriod: "Period",
    filterDateFrom: "From",
    filterDateTo: "To",
    filterAll: "All",
    typeOrders: "Orders (spreadsheet)",
    typeClients: "Clients (spreadsheet)",
    typePluginFile: "Integration file",
    typePluginHistory: "Integration history",
    ordersShort: "Orders",
    clientsShort: "Clients",
    failedShort: "Errors",
    cancelSuccess: "Import cancelled",
    cancelError: "Error cancelling import",
    importData: "Import data",
    chooserTitle: "Import data",
    chooserSubtitle: "Choose what you want to import.",
    newOrders: "Import sales CSV",
    newClients: "Import clients CSV",
    backfillButton: "Import {0} history",
    backfillTitle: "Import history",
    backfillSubtitle: "Choose the period of orders you want to import from the integration.",
    backfillStart: "Start import",
    backfillStarted: "History import started! It will be processed in the background.",
    backfillError: "Could not start the history import.",
    queuedNotice: "Import submitted! It will be processed in the background.",
};
